import { z, ZodType } from 'zod';

export type PlayerVoucherItem = {
	currentDeposit: number;
	totalDeposit: number;
	currentWagering: number;
	totalWagering: number;
};

export const playerVoucherItemSchema: ZodType<PlayerVoucherItem> = z.object({
	currentDeposit: z.number(),
	totalDeposit: z.number(),
	currentWagering: z.number(),
	totalWagering: z.number(),
});
